import React, { useState } from "react";

import Search from "components/Search";
import LinkListItem from "components/LinkListItem";
import { SearchContainer } from "../styles";
import { dedupeResults, getSiteSearchResults } from "./utils";

const SearchBar = ({ closeHandler }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [remainingResults, setRemainingResults] = useState(0);
  const [query, setQuery] = useState("");

  const search = async (query) => {
    const results = await getSiteSearchResults({ query });
    const dedupedResults = dedupeResults(results);
    setRemainingResults(
      dedupedResults.length > 5
        ? dedupedResults.length - 5
        : dedupedResults.length
    );
    setSearchResults(dedupedResults);
  };

  const handleInputChange = async (evt) => {
    const _query = evt?.target?.value ?? null;
    /* if (!_query || _query === "" || _query?.length < 3) {
      return;
    }

    await search(_query); */
    setQuery(_query);
  };

  return (
    <SearchContainer
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="300"
    >
      <Search onChange={handleInputChange} onSearch={() => search(query)}>
        {(searchResults.length && [
          ...searchResults
            .filter((_, index) => index < 5)
            .map((result, index) => {
              const {
                fields: { id = "search-list-item", title = "", url },
              } = result;
              return (
                <LinkListItem
                  key={`${id}-${index}`}
                  iconType="Search"
                  linkURL={url}
                  text={title}
                  navProps={result}
                />
              );
            }),
          <LinkListItem
            key={`more-results-key`}
            linkURL={`/search`}
            navProps={{ searchResults }}
            cb={closeHandler}
          >
            <div>{`+ ${remainingResults} More Results`}</div>
            <div>See More</div>
          </LinkListItem>,
        ]) ||
          null}
      </Search>
    </SearchContainer>
  );
};

export default SearchBar;
